import * as React from 'react';
export const upiSvg = React.forwardRef(function upiSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      null,
      /*#__PURE__*/ React.createElement(
        'g',
        null,
        /*#__PURE__*/ React.createElement('path', {
          d: 'M26.652 3.027c.288 0 .5.095.636.285.116.162.153.362.107.603l-.03.124-1.102 3.986c-.077.28-.24.515-.483.705a1.29 1.29 0 0 1-.647.277l-.139.007h-8.908L14.985 13h-1.982l1.643-5.942h1.982v.004h7.924l.578-2.083h-9.906l.537-1.952h10.89Zm-22.133 0-2.226 8.025h7.928l2.226-8.025h1.982l-2.582 9.304a.913.913 0 0 1-.876.669H.753c-.28 0-.487-.095-.623-.285-.135-.19-.167-.424-.086-.705l2.493-8.983h1.982Zm29.975-.009L37 8.007l-5.27 4.988.627-2.263-2.391 2.263 2.767-9.977 1.135 2.26.626-2.26ZM31.072 3l-2.754 9.955h-1.983L29.09 3h1.982Z',
        }),
      ),
    ),
  );
});
upiSvg.defaultProps = {
  width: '38',
  height: '16',
  viewBox: '0 0 38 16',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var upi = {
  category: 'paymentmethod',
  colorable: true,
  name: 'upi',
  svg: upiSvg,
};
